// A stored boolean always wins; only an unset preference uses the venue default.
export const isInvitationNavigationEnabled = ({ withWazeLink, locationAddress } = {}) =>
  typeof withWazeLink === "boolean" ? withWazeLink : Boolean(String(locationAddress || "").trim());
